import { apiGet } from '~/utils/api'

export interface StaticPageItem {
  id: string
  slug: string
  title: string
  content: string
  metaDescription: string
  updatedAt: string
}

/**
 * 前台静态页面 API
 */
export function useStaticPage() {
  const { locale } = useI18n()

  async function fetchPage(slug: string): Promise<StaticPageItem> {
    return await apiGet<StaticPageItem>(`/api/app/v1/pages/${slug}?locale=${locale.value}`)
  }

  async function fetchPages(): Promise<StaticPageItem[]> {
    return await apiGet<StaticPageItem[]>(`/api/app/v1/pages?locale=${locale.value}`)
  }

  return {
    fetchPage,
    fetchPages,
  }
}
